import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import throttle from 'lodash.throttle';
import { inViewForReact } from 'utils/common';
import SocialPrimeWidget from 'components/SocialPrimeWidget/SocialPrimeWidgetLoader';
import SocialSharingWeb from '../SocialSharingWeb';
import { setIsStickyHeaderVisible } from '../../../../../reduxUtils/modules_v2/common';
import s from './StickyHeader.scss';

class StickyHeader extends React.Component {
  constructor() {
    super();
    this.state = {
      show: false,
      width: 0,
    };

    this.scrollVal = 0;
    this.shareElemVisible = false;
  }

  componentDidMount() {
    window.addEventListener('scroll', this.monitorScroll());
    this.setShareElem();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.monitorScroll());
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.msid !== prevProps.msid) {
      this.setShareElem();
    }

    if (this.state.show !== prevState.show && this.props.enableStickyBehavior) {
      // dispatch
      this.props.setIsStickyHeaderVisible(this.state.show);
    }
  }

  setShareElem = () => {
    this.shareElem = document.querySelector(
      `[data-socialshare="${this.props.msid}"]`,
    );

    this.bottomshareElem = document.querySelector(
      `[data-bottomsocialshare="${this.props.msid}"]`,
    );

    this.articleElem = document.querySelector(
      `[data-articlemsid="${this.props.msid}"] [data-articlebody="1"]`,
    );
  };

  monitorScroll = () => throttle(this.handleScrollEvent, 100);

  resetShareElem = () => {
    // bottomshareElem reference remains null if perpetual article is in collapsed mode
    if (this.bottomshareElem === null) this.setShareElem();
  };

  handleScrollEvent = () => {
    // reset Share elem references if they are loaded upon clicking readFullArticle CTA
    this.resetShareElem();
    const currentScrollVal = window.pageYOffset;
    // const scrollingDown = currentScrollVal > this.scrollVal;
    this.scrollVal = currentScrollVal;
    // Below code if for primeshow
    if (this.props.toipLayout && this.shareElem) {
      const elemRect = this.shareElem.getBoundingClientRect();
      let show = false;
      if (elemRect && elemRect.top <= 10) {
        show = true;
      }
      if (this.state.show !== show) {
        this.setState({ show });
      }
      this.getArticleScrolledVal();
    }
    if (this.shareElem && this.bottomshareElem) {
      // const isInView = inViewForReact(this.shareElem);
      //const isInViewArticle = inViewForReact(this.articleElem, 80, true);
      const elemRect = this.shareElem.getBoundingClientRect();
      const elemBottomRect = this.bottomshareElem.getBoundingClientRect();
      let show = false;
      if (
        //isInViewArticle &&
        elemRect &&
        elemRect.top <= 40 &&
        elemBottomRect &&
        elemBottomRect.top - window.innerHeight > 0
      ) {
        show = true;
      }

      if (this.state.show !== show) {
        this.setState({ show });
      }

      this.getArticleScrolledVal();
    }
  };

  getArticleScrolledVal = () => {
    const targetElement =
      this.articleElem || (this.props.toipLayout && this.shareElem);
    if (targetElement) {
      try {
        const isInView = inViewForReact(targetElement, 0, true);
        let width = 0;
        const elemRect = targetElement.getBoundingClientRect();
        if (elemRect && isInView && elemRect.top < 0) {
          const articleHeight = targetElement.offsetHeight - window.innerHeight;
          const articleScrolled = Math.abs(elemRect.top);
          width = Math.min(articleScrolled / articleHeight * 100, 100);
        }

        if (this.state.width !== width) {
          this.setState({ width });
        }
      } catch (e) {
        // console.log(e);
      }
    }
  };

  render() {
    const {
      categoryForGA,
      gaAction,
      gaIndex,
      ga4Data,
      hideSocialSharing = false,
      articleshowData,
      toipLayout,
      commentCount,
      emailId,
    } = this.props;
    return (
      <div
        className={`${s.stickyheader} ${toipLayout ? s.toipHeaderSticky : ''} ${
          // eslint-disable-next-line no-nested-ternary
          this.state.show && !toipLayout
            ? s.show
            : this.state.show ? s.primeShowStickyHeader : 'hide'
        } ${this.props.isAppView ? s.appview : ''}`}
      >
        <div className={`${s.wrapper} contentwrapper clearfix`}>
          <div className={`${s.title} ${toipLayout ? s.primeShowTitle : ''}`}>
            {toipLayout && <span className={s.nowReading}>Now Reading:</span>}
            {this.state.show && this.props.title}
          </div>
          {!hideSocialSharing && (
            <div className={`${s.share} share`}>
              <SocialSharingWeb
                textRequired={false}
                {...this.props}
                tpShow
                linkeDin
                showComment
                topsticky
                gaCategory={categoryForGA}
                gaAction={gaAction}
                gaIndex={gaIndex}
                ga4Data={ga4Data}
              />
            </div>
          )}
          {toipLayout && (
            <div className={s.socialwrapper}>
              <SocialPrimeWidget
                isWapView={this.props.isWapView}
                msid={articleshowData.id}
                url={articleshowData.su || articleshowData.wu}
                title={articleshowData.hl}
                commentsCount={commentCount}
                openSideBar={this.props.openSideBar}
                updateFontSize={this.props.updateFontSize}
                fontSize={this.props.fontSize}
                emailId={emailId}
                toipLayout={toipLayout}
              />
            </div>
          )}
        </div>
        <div
          className={`${s.background} ${
            toipLayout ? s.primeshowBackground : ''
          }`}
          style={{ width: `${this.state.width}%` }}
        />
      </div>
    );
  }
}

StickyHeader.propTypes = {
  title: PropTypes.string,
  msid: PropTypes.string.isRequired,
  isAppView: PropTypes.bool,
  categoryForGA: PropTypes.string,
  gaAction: PropTypes.string,
  gaIndex: PropTypes.string,
  ga4Data: PropTypes.string,
  hideSocialSharing: PropTypes.bool,
  enableStickyBehavior: PropTypes.bool,
  setIsStickyHeaderVisible: PropTypes.func,
};

StickyHeader.defaultProps = {
  title: '',
  isAppView: false,
  categoryForGA: 'sticky_header',
  gaAction: 'click',
  gaIndex: 'atfStickyShare_',
  ga4Data: '',
  hideSocialSharing: false,
  enableStickyBehavior: false,
  setIsStickyHeaderVisible: () => {},
};

const mapStateToProps = () => ({});

const mapDispatchtoProps = dispatch => ({
  setIsStickyHeaderVisible: flag => {
    dispatch(setIsStickyHeaderVisible(flag));
  },
});

export default connect(mapStateToProps, mapDispatchtoProps)(StickyHeader);
